// src/service/api/settingsApi.js

import axiosInstance from "utils/axiosInstance";

const settingsApi = {
  /**
   * Fetches settings from the backend
   * @param {string} category - The category of settings to fetch
   * @returns {Promise<Array>} A promise that resolves to an array of setting objects
   */
  getSettings: async (category = "work") => {
    const response = await axiosInstance.get(`/settings/getall/?category=${category}`);
    return response.data || [];
  },

  /**
   * Initializes work hours settings
   * @returns {Promise<Object>} A promise that resolves to the response data
   */
  initializeWorkHours: async () => {
    const response = await axiosInstance.post("/settings/seed/init-work-hours");
    return response.data;
  },

  /**
   * Toggles a setting's active status
   * @param {string} settingId - The ID of the setting to toggle
   * @param {string} employeeType - The employee type ("permanent" or "contract")
   * @returns {Promise<Object>} A promise that resolves to the response data
   */
  toggleSetting: async (settingId, employeeType) => {
    const response = await axiosInstance.put(`/settings/update/toggle/${settingId}`, {
      employee_type: employeeType
    });
    return response.data;
  },

  /**
   * Updates a setting's value
   * @param {string} settingId - The ID of the setting to update
   * @param {string} employeeType - The employee type ("permanent" or "contract")
   * @param {string} value - The new value for the setting
   * @returns {Promise<Object>} A promise that resolves to the response data
   */
  updateSettingValue: async (settingId, employeeType, value) => {
    const response = await axiosInstance.put(`/settings/update/value/${settingId}`, {
      employee_type: employeeType,
      value: value
    });
    return response.data;
  }
};

export default settingsApi;